// What? The config the IDA Stop hook reads.
// Why? Stop must cancel the run on the server and end the stream only after the server
//      confirms. useChat().cancelStream, which IDA calls to end the local stream, is itself the
//      server-confirmed Stop when the provider config sets cancelSubmission, so the provider
//      config leaves it off and only the Stop hook's copy turns it on (no double cancel).
// How? A copy of the provider config with cancelSubmission on.
export function withServerStop<T extends object>(
  config: T | null,
): (T & { cancelSubmission: true }) | null {
  return config ? { ...config, cancelSubmission: true as const } : null;
}
